import { module } from 'angular';
import App from '../../../app';

class SCR1502Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(720, 640);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initTrxCdGridOption();
			this.getTrxCodes();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			trxCdSearch : bxMsg('manageTrxCode.trxCdSearch'),
			trxCd : bxMsg('manageTrxCode.trxCd'),
			trxCdNm : bxMsg('manageTrxCode.trxCdNm'),
			select : bxMsg('common.select'),
			cancel : bxMsg('common.cancel'),
			search : bxMsg('common.search'),
			resetSearch : bxMsg('common.resetSearch')
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initTrxCdGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "trxCd"}, {fieldName: "trxCdNm"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "trxCd", fieldName: "trxCd", header : { text: this.text.trxCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "trxCdNm", fieldName: "trxCdNm", header : { text: this.text.trxCdNm }, width: 100, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getTrxCodes(goToFirst = false) {
		const {pageNumber, pageSize} = this.getPageInfo();
		let url = `/trxs?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.trxcdOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getTrxCodes(true);
	}
	
	search(){
		this.getTrxCodes(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getTrxCodes(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
	
}

module(App.name).controller('SCR1502Controller', SCR1502Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1502/SCR1502.controller.js